import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose?: () => void;
}

const Completed: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className='box-success center-item-success'>
      <div className="content-success center-item-success">
        <div className="image">
          <img src="/assets/images/icons/success-employer.svg" alt="success" />
        </div>
        <div className="text">
          <div style={{ fontSize: '25px' }} className='text__title text-worker my-2'>
            {t('USERS_PAGE.UPDATE_USER.UPDATE_WORKER_SUCCESS')}
          </div>
        </div>
      </div>
      {onClose && (
        <div className="btn-finish">
          <button 
            className='btn-create-emp btn btn-dark fs-14' 
            style={{ width: '211px', height: '50px' }} 
            onClick={onClose}
          >
            {t('CLOSE')}
          </button>
        </div>
      )}
    </div>
  )
}

export { Completed }
